/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const CfarStatus = {
    Created: 'created',
    Confirmed: 'confirmed',
    Failed: 'failed',
    ChargedBack: 'charged_back',
    Voided: 'voided',
    Canceled: 'canceled'
};
export function CfarStatusFromJSON(json) {
    return CfarStatusFromJSONTyped(json, false);
}
export function CfarStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CfarStatusToJSON(value) {
    return value;
}
